//
//
//
//
//
//

import headMixin from '~/mixins/head.mixin'

export default {
  name: 'CodingPage',
  layout: ({ store, redirect }) => {
    if (!store.getters['landings/landingIsActive']) {
      return redirect('/coding')
    }

    return 'faculty'
  },
  mixins: [headMixin],
  computed: {
    component() {
      return () => import(`~/components/page/redesign/math/MathPage.vue`)
    },
  },
}
